import tracking from 'dibs-tracking';
import { getPromoCreative } from '../../homepage/helpers/getPromoCreative';

function getShopByPromoObj({ position, creative }) {
    return {
        id: `shop-by-l1-creator`,
        name: `Shop by L1 Creator`,
        creative,
        position,
    };
}

function trackShopByItemsImpressions(items) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) => {
            const url = item?.linkData?.path || '';
            const position = index + 1;
            return getShopByPromoObj({
                creative: getPromoCreative(url),
                position,
            });
        }),
    });
}

function trackShopByItemClick(item, index) {
    const url = item?.linkData?.path || '';
    const position = index + 1;
    const promoObj = getShopByPromoObj({
        creative: getPromoCreative(url),
        position,
    });

    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [promoObj],
    });
}

function trackShopByLocationsImpressions(index, locationUrl = 'none', isPersonalized = false) {
    const variantType = isPersonalized ? 'personalized' : 'default';
    const position = index + 1;
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: [
            {
                id: 'shop-by-local-module',
                name: 'shop by local module',
                creative: locationUrl,
                position,
                variant: `${variantType} location`,
            },
        ],
    });
}

function trackShopByLocationClick(item, index) {
    const url = item?.linkData?.path || '';
    const position = index + 1;
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: 'shop-by-location',
                name: 'Shop by Location',
                creative: getPromoCreative(url),
                position: position,
            },
        ],
    });
}

export {
    trackShopByItemsImpressions,
    trackShopByLocationsImpressions,
    trackShopByItemClick,
    trackShopByLocationClick,
};
